import { lazy } from 'react';

const AddCollegeAppModal = lazy(() => import('./AddCollegeAppModal'));
const ApplicationListModal = lazy(() => import('./ApplicationListModal'));
const MarkAsCompleteModal = lazy(() => import('./MarkAsCompleteModal'));

export default {
  ADD_COLLEGE_APPLICATION: AddCollegeAppModal,
  APPLICATION_LIST_MODAL: ApplicationListModal,
  MARK_AS_COMPLETE_MODAL: MarkAsCompleteModal,
};
